import React, { Component } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { withNamespaces } from 'react-i18next'
import { Col } from 'reactstrap'
import styled from 'styled-components'

import ContractCard from '../../Contracts/ContractCard'
import ManagerCard from '../../Contracts/ManagerCard'
import Divider from '../../Contracts/Divider'
import ProductCard from '../../Contracts/ProductCard'
import MobilePropertySelect from '../../MobilePropertySelect'

import Preloader from '../../../components/UI/Preloader'

import { fetchContract } from '../../../ducks/contracts'

const Wrapper = styled.div`
  margin-top: 20px;
`

const MobilePropertySelectWrapper = styled.div`
  margin-bottom: 20px;
`

const RowWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-left: -15px;
  margin-right: -15px;
  align-items: stretch;
`

const ColumnWrapper = styled.div`
  position: relative;
  width: 100%;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;

  flex: 1 1 33.333333%;
  max-width: 33.333333%;
  display: flex;

  @media (max-width: 992px) {
    flex: 1 1 50%;
    max-width: 50%;
  }

  @media (max-width: 768px) {
    flex: 1 1 100%;
    max-width: 100%;
  }
`

class ContractsPage extends Component {
  componentDidMount() {
    this.props.fetchContract()
  }

  render() {
    const { loading } = this.props.contracts

    return (
      <Wrapper>
        {loading && <Preloader />}
        <RowWrapper>
          <Col xs={12} className="d-md-none">
            <MobilePropertySelectWrapper>
              <MobilePropertySelect />
            </MobilePropertySelectWrapper>
          </Col>
        </RowWrapper>
        <RowWrapper>
          {this.renderContracts()}
          {this.renderManager()}
        </RowWrapper>
        <Divider />
        <RowWrapper>{this.renderProducts()}</RowWrapper>
      </Wrapper>
    )
  }

  renderContracts = () => {
    const { contracts } = this.props.contracts

    if (!contracts.length) {
      return null
    }

    return contracts.map((contract) => {
      return (
        <ColumnWrapper key={contract.id} md={4}>
          <ContractCard {...contract} />
        </ColumnWrapper>
      )
    })
  }

  renderManager = () => {
    const { manager } = this.props.contracts

    if (!manager || !manager.employee_id) {
      return null
    }

    return (
      <ColumnWrapper md={4}>
        <ManagerCard {...manager} />
      </ColumnWrapper>
    )
  }

  renderProducts = () => {
    const { products, selectedPropertyId } = this.props.contracts

    if (!products.length) {
      return null
    }

    return products.map((product) => {
      return (
        <ColumnWrapper key={product.product_id}>
          <ProductCard propertyId={selectedPropertyId} product={product} />
        </ColumnWrapper>
      )
    })
  }
}

export default compose(
  connect(
    ({ contracts }) => ({ contracts }),
    { fetchContract }
  ),
  withNamespaces()
)(ContractsPage)
